import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import CustomListBoxWithShowMore from "./CustomListBoxWithShowMore";

const AutoCompleteDropdown = ({
  label,
  data = [],
  initValue = null,
  noOptionsText = "No Results",
  onValueChange = () => {},
  onInputChange = () => {},
  freeSolo = false,
  multiple = false,
  nextPageURL = null,
  getOptionLabel = (option) => option?.label || option || "",
  isOptionEqualToValue = (option, value) =>
    option?.id === value?.id || option === value,
  ListboxComponent = CustomListBoxWithShowMore,
  ListboxProps = {},
  filterOptions
}) => {
  const [selectedValue, setSelectedValue] = useState(initValue ?? (multiple ? [] : null));

  const handleChange = (event, value) => {
    setSelectedValue(value);
    onValueChange(event, value);
  };

  useEffect(() => {
    setSelectedValue(initValue ?? (multiple ? [] : null));
  }, [initValue, multiple]);

  return (
    <Autocomplete
      multiple={multiple}
      disablePortal
      freeSolo={freeSolo}
      options={data}
      getOptionLabel={getOptionLabel}
      {...(filterOptions ? { filterOptions } : {})}
      value={selectedValue}
      noOptionsText={noOptionsText}
      isOptionEqualToValue={isOptionEqualToValue}
      className="w-full"
      renderInput={(params) => (
        <TextField {...params} label={label} />
      )}
      onChange={handleChange}
      onInputChange={onInputChange}
      ListboxComponent={ListboxComponent}
      ListboxProps={{
        ...ListboxProps,
        nextPageURL,
      }}
    />
  );
};

export default AutoCompleteDropdown;
